import React from 'react';
import { Minus, Plus, Maximize2, RotateCcw } from 'lucide-react';

interface ZoomControlsProps {
  zoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onZoomReset: () => void;
  onFitToScreen: () => void;
  onZoomChange: (zoom: number) => void;
}

export const ZoomControls: React.FC<ZoomControlsProps> = ({
  zoom,
  onZoomIn,
  onZoomOut,
  onZoomReset,
  onFitToScreen,
  onZoomChange,
}) => {
  const handleZoomInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value >= 10 && value <= 500) {
      onZoomChange(value / 100);
    }
  };

  return (
    <div className="fixed bottom-4 right-4 bg-white rounded-lg shadow-lg p-3 flex items-center gap-2 z-50 border border-gray-200">
      {/* Zoom Out Button */}
      <button
        onClick={onZoomOut}
        className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        title="Zoom Out (-)">
        <Minus className="w-4 h-4" />
      </button>

      {/* Zoom Input */}
      <div className="flex items-center gap-1">
        <input
          type="number"
          value={Math.round(zoom * 100)}
          onChange={handleZoomInputChange}
          className="w-14 text-center border border-gray-200 rounded px-1 py-1 text-sm"
          min="10"
          max="500"
        />
        <span className="text-sm text-gray-500">%</span>
      </div>

      {/* Zoom In Button */}
      <button
        onClick={onZoomIn}
        className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        title="Zoom In (+)">
        <Plus className="w-4 h-4" />
      </button>

      <div className="w-px h-6 bg-gray-300" />

      {/* Fit to Screen Button */}
      <button
        onClick={onFitToScreen}
        className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        title="Fit to Screen">
        <Maximize2 className="w-4 h-4" />
      </button>

      {/* Reset Zoom Button */}
      <button
        onClick={onZoomReset}
        className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        title="Reset Zoom (100%)">
        <RotateCcw className="w-4 h-4" />
      </button>

      {/* Keyboard Shortcuts Info */}
      <div className="hidden md:flex items-center gap-2 ml-2 text-xs text-gray-500 border-l border-gray-300 pl-3">
        <span>⌘+Scroll: Zoom</span>
        <span>•</span>
        <span>Pinch: Zoom</span>
      </div>
    </div>
  );
};